import { colors, screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import PercentageBar from './PercentageBar';

export interface PollCardProps {
  title: string;
  breakdownByCarNeed: {
    mustHave: number;
    niceToHave: number;
    canGetByWithout: number;
    notReally: number;
    noNeed: number;
  };
}

export default function PollCard(props: PollCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="aggregate-card">
      <div className="poll-header">{t('seoSrp.drivingTipsAndExperiences.pollHeader')}</div>
      <div className="poll-question">
        {t('seoSrp.drivingTipsAndExperiences.pollTitle')}
        {` ${props.title}?`}
      </div>
      <div className="divider" />
      <div className="poll-answer-container">
        <PercentageBar
          label={t('seoSrp.drivingTipsAndExperiences.mustHave')}
          value={props.breakdownByCarNeed.mustHave}
        />
        <PercentageBar
          label={t('seoSrp.drivingTipsAndExperiences.niceToHave')}
          value={props.breakdownByCarNeed.niceToHave}
        />
        <PercentageBar
          label={t('seoSrp.drivingTipsAndExperiences.canGetByWithout')}
          value={props.breakdownByCarNeed.canGetByWithout}
        />
        <PercentageBar
          label={t('seoSrp.drivingTipsAndExperiences.notReally')}
          value={props.breakdownByCarNeed.notReally}
        />
        <PercentageBar
          label={t('seoSrp.drivingTipsAndExperiences.noNeed')}
          value={props.breakdownByCarNeed.noNeed}
        />
      </div>

      <style jsx>{`
        .aggregate-card {
          margin: 0 10px 32px 10px;
          padding: 0 24px;
          border: 1px solid ${colors.G2};
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        }

        @media (min-width: ${screen.xsMax}) and (max-width: 849px) {
          .aggregate-card {
            width: 600px;
            margin-right: 32px;
          }
        }

        .poll-header {
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          text-align: left;
          letter-spacing: 0.2px;
          color: ${colors.ALB2};
          margin-top: 24px;
          width: 100%;
        }

        .poll-question {
          font-weight: 700;
          font-size: 24px;
          line-height: 30px;
          text-align: left;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          margin: 0 0 24px 0;
        }

        .overall-rating-container {
          display: flex;
          flex-direction: column;
          margin-bottom: 42px;
          height: 26px;
        }

        .poll-answer-container {
          padding-bottom: 16px;
          width: 100%;
        }

        .divider {
          height: 1px;
          width: 252px;
          background-color: ${colors.G2};
          margin-bottom: 24px;
        }

        @media (min-width: ${screen.xsMax}) and (max-width: 849px) {
          .divider {
            width: 552px;
          }
        }

        @media (min-width: 850px) {
          .aggregate-card {
            width: 300px;
            margin: 0 0 0 24px;
          }
        }
        @media (min-width: 1440px) {
          .aggregate-card {
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
}
